import { render } from "./RepairCenter.vue?vue&type=template&id=05035000"
import script from "./RepairCenter.vue?vue&type=script&lang=js"
export * from "./RepairCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__